import { DatePicker, Space, Select, Table, message, Spin, Form, Image, Tooltip, Button, Row, Col } from 'antd';
import dayjs from 'dayjs';
import { FileExcelOutlined } from '@ant-design/icons';
import constants from '../../constants/constants';
import { useContext, useEffect, useState } from 'react';
import debounce from 'lodash/debounce';
import WebLinks from '../../api/WebLinks';
import Cookies from 'js-cookie';
import APIUtils from '../../api/APIUtils';
import { GetCustomPriorityLevelIcons, GetPriorityLevelColors, downloadFiles } from '../../globalFunctions/GlobalFunctions';
import { CommonContext } from '../../Context';
const { RangePicker } = DatePicker;
const { Option } = Select

const SpendPerJobSuppliers = (props) => {

	//Variable declaration
	const columns = [
		{
			title: 'Month/Supplier',
			dataIndex: 'supplierName',
			key: 'supplierName',
			sorter: (a, b) => a.supplierName.length - b.supplierName.length,
			render: (_, record) => {
				return (
					<>
						{record.logoURL && record.logoURL !== "" ?
							<Image src={record.logoURL} preview={false} width={100} /> :
							<span>{record.supplierName}</span>
						}
					</>
				)

			}
		},
		{
			title: 'Applies',
			dataIndex: 'applies',
			key: 'applies',
			align: 'center',
			sorter: (a, b) => a.applies - b.applies,
		},
		{
			title: 'Cost',
			dataIndex: 'totalCost',
			key: 'totalCost',
			align: 'center',
			sorter: (a, b) => a.totalCost - b.totalCost,
		},
		{
			title: 'Cost/Apply',
			dataIndex: 'totalCostApplies',
			key: 'totalCostApplies',
			align: 'center',
			sorter: (a, b) => a.totalCostApplies - b.totalCostApplies,
		},
		{
			title: 'Quality',
			dataIndex: 'quality',
			key: 'quality',
			align: 'center',
			sorter: (a, b) => a.quality - b.quality,
			render: (_, record) => {
				return (
					<Space size={3}>
						<span>{record.quality + " "}</span><span>({record.qualityPer}%)</span>
					</Space>
				)

			}
		},
		{
			title: 'Cost/Quality',
			dataIndex: 'costQuality',
			key: 'costQuality',
			align: 'center',
			sorter: (a, b) => a.costQuality - b.costQuality,
		},
		{
			title: 'Offer',
			dataIndex: 'offer',
			key: 'offer',
			align: 'center',
			sorter: (a, b) => a.offer - b.offer,
			render: (_, record) => {
				return (				
					<Space size={3}>
						{/* {showLinks===true && record.offer>0?
							<Button type='link' 
							onClick={() => handleQualityCountClick(record,2)}
							> */}
							<span>{record.offer + " "}</span><span>({record.offerPer}%)</span>
							{/* </Button>:
					<><span>{record.offer + " "}</span><span>({record.offerPer}%)</span></>
					} */}
					</Space>				
					)
			}
		},
		{
			title: 'Interviews',
			dataIndex: 'interview',
			key: 'interview',
			align: 'center',
			sorter: (a, b) => a.interview - b.interview,
			render: (_, record) => {
				return (
					<>
						<span>{record.interview + " "}</span><span>({record.interviewPer}%)</span>
					</>
				)

			}
		},
		{
			title: 'Cost/Interview',
			dataIndex: 'costInterview',
			key: 'costInterview',
			align: 'center',
			sorter: (a, b) => a.costInterview - b.costInterview,
		},
		{
			title: 'Hires',
			dataIndex: 'hired',
			key: 'hired',
			align: 'center',
			sorter: (a, b) => a.hired - b.hired,
			render: (_, record) => {
				return (
					<Space size={3}>
						<span>{record.hired + " "}</span><span>({record.hiredPer}%)</span>
					</Space>
				)

			}
		},
		{
			title: 'Cost/Hire',
			dataIndex: 'costHired',
			key: 'costHired',
			align: 'center',
			sorter: (a, b) => a.costHired - b.costHired,
		}
	];
	const [spednperJobSupplierData, setSpendPerJobSupplierData] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(25);
	const [rangePickerValue, setRangePickerValue] = useState([]);
	const [loader, setLoader] = useState(false);
	const [totalSpendPerJobSupplierCount, setTotatSpendPerSupplierCount] = useState(0);
	const [spendPerSupplierReportTotal, setSpendPerSupplierReportTotal] = useState([]);
	const [priorityCheck,setPriorityCheck]=useState("f");
  const [buyerListLoader,setBuyerListLoader]= useState(false);
  const [allowedBuyerList, setAllowedBuyerList] = useState([]);
  const [selectedBuyerIds,setSelectedBuyerIds]=useState([]);
	const [form] = Form.useForm();
	const commonContext=useContext(CommonContext);
  const buyerID = commonContext.common.buyerId;

	// Expanded Table
	const expandedTableColumns = [
		{
      title: 'Priority',
      dataIndex: 'priority',
      key: 'priority',
      sorter: (a, b) => a.priority - b.priority,
      align: "center",
			width: '20%',
      render: (text,element) => <Space>
					{/* {GetPriorityLevelIcons(text)} */}
          <div className={priorityCheck==="t"?GetCustomPriorityLevelIcons(element.priorityLevel):GetPriorityLevelColors(element.priorityLevel)}></div>
				</Space>
    },
		{
			title: 'Applies',
			dataIndex: 'applies',
			key: 'applies',
			align: 'center',
			sorter: (a, b) => a.applies - b.applies
		},
		{
			title: 'Cost',
			dataIndex: 'totalCost',
			key: 'totalCost',
			align: 'center',
			sorter: (a, b) => a.totalCost - b.totalCost
		},
		{
			title: 'Cost/Apply',
			dataIndex: 'totalCostApplies',
			key: 'totalCostApplies',
			align: 'center',
			sorter: (a, b) => a.totalCostApplies - b.totalCostApplies
		},
		{
			title: 'Quality',
			dataIndex: 'quality',
			key: 'quality',
			align: 'center',
			sorter: (a, b) => a.quality - b.quality,
			render: (_, record) => {
				return (
					<>
						<span>{record.quality + " "}</span><span>({record.qualityPer}%)</span>
					</>
				)

			}
		},
		{
			title: 'Cost/Quality',
			dataIndex: 'costQuality',
			key: 'costQuality',
			align: 'center',
			sorter: (a, b) => a.costQuality - b.costQuality,
		},
		{
			title: 'Offer',
			dataIndex: 'offer',
			key: 'offer',
			align: 'center',
			sorter: (a, b) => a.offer - b.offer,
			render: (_, record) => {
				return (				
					<Space size={3}>
						{/* {showLinks===true && record.offer>0?
							<Button type='link' 
							onClick={() => handleQualityCountClick(record,2)}
							> */}
							<span>{record.offer + " "}</span><span>({record.offerPer}%)</span>
							{/* </Button>:
					<><span>{record.offer + " "}</span><span>({record.offerPer}%)</span></>
					} */}
					</Space>				
					)
			}
		},
		{
			title: 'Interviews',
			dataIndex: 'interview',
			key: 'interview',
			align: 'center',
			sorter: (a, b) => a.interview - b.interview,
			render: (_, record) => {
				return (
					<>
						<span>{record.interview + " "}</span><span>({record.interviewPer}%)</span>
					</>
				)

			}
		},
		{
			title: 'Cost/Interview',
			dataIndex: 'costInterview',
			key: 'costInterview',
			align: 'center',
			sorter: (a, b) => a.costInterview - b.costInterview,
		},
		{
			title: 'Hires',
			dataIndex: 'hired',
			key: 'hired',
			align: 'center',
			sorter: (a, b) => a.hired - b.hired,
			render: (_, record) => {
				return (
					<Space size={3}>
						<span>{record.hired + " "}</span><span>({record.hiredPer}%)</span>
					</Space>
				)

			}
		},
		{
			title: 'Cost/Hire',
			dataIndex: 'costHired',
			key: 'costHired',
			align: 'center',
			sorter: (a, b) => a.costHired - b.costHired,
		}
	];

	useEffect(() => {
		const date1 = dayjs().startOf('month')
		const date2 = dayjs().endOf('month')
		form.setFieldsValue({
			rangePicker: [
				date1,
				date2,
			],
		});
		setRangePickerValue([
			date1.format(constants.MonthFormat),
			date2.format(constants.MonthFormat),
		]);
    getAllowedBuyers();
		GetSpendPerJobSupplierReportData(1, 25,
			date1.format(constants.MonthFormat),
			date2.format(constants.MonthFormat));
	}, []);


	//Functions
	//Function runs when range picker value is changed
	const RangePickerChanged = debounce((_, dateStrings) => {
		//props.changeDate(dateStrings);
		setRangePickerValue([
			dayjs(dateStrings[0], constants.MonthFormat),
			dayjs(dateStrings[1], constants.MonthFormat),
		]);
		GetSpendPerJobSupplierReportData(currentPage, pageSize, dateStrings[0], dateStrings[1],selectedBuyerIds);
	}, 500);

	//Function to Month report data
	const GetSpendPerJobSupplierReportData = async (currentPage, pazeSize, startDate, endDate,buyerId=null) => {
		setLoader(true);
    let url=WebLinks.GetApplicationSpendPerJobSupplierReport +buyerID + "&fromDate=" + startDate + "&toDate=" + endDate + "&limit=" + pazeSize + "&pageNo=" + currentPage;
    if(buyerId && buyerId.length>0){
      url += "&selectedBuyerId=" + buyerId;
    }
		const response = await APIUtils.apiCall('GET', url);
		if (!response.isCatch && response.resultObj.statusCode === "2000") {
			setSpendPerSupplierReportTotal(response.resultObj.data.pop());
			setSpendPerJobSupplierData(response.resultObj.data);
			setTotatSpendPerSupplierCount(response.resultObj.getCount);
			setPriorityCheck(response?.resultObj?.data?.morePriorityLevels===true?"t":"f");
			setLoader(false);
		} else {
			setSpendPerJobSupplierData([]);
			setPriorityCheck("f");
			setLoader(false);
			message.error(response?.resultObj?.message);
		}
	}

	//Function to get Allowed suppliers list
	const getAllowedBuyers =async()=>{
		setBuyerListLoader(true);
		const response = await APIUtils.apiCall('GET',WebLinks.GEtSubBuyerAllotedList+buyerID);
		if(!response.isCatch && response.resultObj.statusCode==="2000"){
			setAllowedBuyerList(response?.resultObj?.data||[])
			setBuyerListLoader(false);
		}else{
			setAllowedBuyerList([]);
			setBuyerListLoader(false);
			message.error(response.resultObj.message);
		}
	}

	//Function to download as excel
	const downloadFile = () => {
		setLoader(true)
    let url=WebLinks.DownloadApplicationSpendPerSupplierReport+buyerID + `&fromDate=${dayjs(rangePickerValue[0]).format(constants.MonthFormat)}&toDate=${dayjs(rangePickerValue[1]).format(constants.MonthFormat)}`;
    if(selectedBuyerIds && selectedBuyerIds.length>0){
      url += "&selectedBuyerId=" + selectedBuyerIds;
    }
		downloadFiles(url,"ApplicationSuppliersReport.xlsx");
		setTimeout(() => {
				setLoader(false)
		}, 3000);
	};

	//Funcion to render inner table
	const getInnerTable = (tableData) => {
		return (
			<Table
				bordered
				size="small"
				columns={expandedTableColumns}
				dataSource={tableData}
				pagination={false}
			/>
		)
	}

	//Function on change of buyer selection
	const handleBuyerSelect=(selectedBuyers)=>{
		if(selectedBuyers.length>0){
			let tempSelectedBuyers=selectedBuyers.filter(value => value !== 'showall');
			let selectedBuyersFinal=tempSelectedBuyers.length>0?tempSelectedBuyers:"";
			form.setFieldsValue({
				buyerList:selectedBuyersFinal
			})
			setSelectedBuyerIds(selectedBuyersFinal);
      GetSpendPerJobSupplierReportData(currentPage, pageSize,rangePickerValue[0], rangePickerValue[1],selectedBuyersFinal);
		}else{
			form.setFieldsValue({
				buyerList:["showall"]
			})
			setSelectedBuyerIds([]);
      GetSpendPerJobSupplierReportData(currentPage, pageSize,rangePickerValue[0], rangePickerValue[1],null);
		}
	}

	//Function to display the month total in the table
	const monthReportSummary = () => {
		return (
			<>
				<Table.Summary.Row className='bg-teal-50'>
				<Table.Summary.Cell index={0} align='center'>
					</Table.Summary.Cell>
					<Table.Summary.Cell index={1} align='center'>
						<strong>Totals</strong>
					</Table.Summary.Cell>
					<Table.Summary.Cell index={2} className='text-center'>
						<strong>{spendPerSupplierReportTotal.applies}</strong>
					</Table.Summary.Cell>
					<Table.Summary.Cell index={3} className='text-center'>
						<strong>{spendPerSupplierReportTotal.totalCost}</strong>
					</Table.Summary.Cell>
					<Table.Summary.Cell index={4} className='text-center'>
						<strong>{spendPerSupplierReportTotal.totalCostApplies}</strong>
					</Table.Summary.Cell>
					<Table.Summary.Cell index={5} className='text-center'>
						<strong><Space size={3}>{spendPerSupplierReportTotal.quality||"" + " "}<span>({spendPerSupplierReportTotal.qualityPer||0}%)</span></Space></strong>
					</Table.Summary.Cell>
					<Table.Summary.Cell index={6} className='text-center'>
						<strong>{spendPerSupplierReportTotal.costQuality}</strong>
					</Table.Summary.Cell>
					<Table.Summary.Cell index={6} className='text-center'>
						<strong><Space size={3}>{spendPerSupplierReportTotal.offer||"" + " "}<span>({spendPerSupplierReportTotal.offerPer||0}%)</span></Space></strong>
					</Table.Summary.Cell>
					<Table.Summary.Cell index={7} className='text-center'>
						<strong><Space size={3}>{spendPerSupplierReportTotal.interview||"" + " "}<span>({spendPerSupplierReportTotal.interviewPer||0}%)</span></Space></strong>
					</Table.Summary.Cell>
					<Table.Summary.Cell index={8} className='text-center'>
						<strong>{spendPerSupplierReportTotal.costInterview}</strong>
					</Table.Summary.Cell>
					<Table.Summary.Cell index={9} className='text-center'>
						<strong><Space size={3}>{spendPerSupplierReportTotal.hired||"" + " "}<span>({spendPerSupplierReportTotal.hiredPer||0}%)</span></Space></strong>
					</Table.Summary.Cell>
					<Table.Summary.Cell index={10} className='text-center'>
						<strong>{spendPerSupplierReportTotal.costHired}</strong>
					</Table.Summary.Cell>
				</Table.Summary.Row>
			</>
		)
	};

	return (
		<>
			<Spin spinning={loader}>
				<div>
					<div className='flex flex-wrap gap-3 justify-between items-center mb-3'>
						<Row gutter={[12,12]}>
							<Col>
							<Space wrap>
							<Form form={form}>
								<Form.Item name="rangePicker" className='mb-0'>
									<RangePicker picker="month"
										placeholder={["From", "To"]}
										onChange={RangePickerChanged}

										format={constants.MonthFormat} />
								</Form.Item>
							</Form>
						<Tooltip placement='right' title="Download as Excel">
								<Button
										className='bg-green-800 text-white hover:!text-white hover:!border-green-500'
										icon={<FileExcelOutlined />}
										onClick={()=>{downloadFile()}}
								>
									Download as Excel
								</Button>
						</Tooltip> 
						</Space>
						</Col>
						<Col>
						<Space wrap>
						<label>Filter by Buyer</label>
						<Form.Item name="buyerList" className='mb-0'>
							<Select
								loading={buyerListLoader}
								className='!w-60'
								placeholder={"Buyer"}
								mode='multiple'
								allowClear
								defaultValue={"showall"}
								showSearch
							filterOption={(input, option) =>
									option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
									option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
							}
								onChange={(e) => handleBuyerSelect(e)}
								>
									<Option key='showall' value='showall'>Show all</Option>
										{allowedBuyerList?.map((buyer) => (
											<Option key={buyer.subPartnerId}
													value={buyer.subPartnerId}
											>
											{buyer.name}</Option>
								))}
							</Select>
						</Form.Item>
						</Space>
						</Col>
						</Row>
					</div>
					<div className='overflow-x-auto'>
						<Table
							columns={columns}
							dataSource={spednperJobSupplierData}
							scroll={{
								x: 1000,
							}}
							sortDirections={['descend', 'ascend', 'descend']}
							rowKey="supplierId"
							expandable={{
								expandedRowRender: (record) => (<div>
									{getInnerTable(record.priorityLevelMonthReport)}
								</div>)
							}}
							pagination={{
								total: totalSpendPerJobSupplierCount,
								defaultPageSize: 100,
							}}
							summary={() => monthReportSummary()}
						/>
					</div>
				</div>
			</Spin>
		</>
	);
};

export default SpendPerJobSuppliers;